import { RESET_SELECTED_FUND, UPDATE_CART_ITEM_BY_SCHEME_CODE } from '../../types/quickbuy';
import * as type from '../../types/trans';

let init = {
    schemeCode: null,
    cartBoxData: [],
    activeInvestor: "",
    investorDrop: [],
    panFolio: [],
    folioSelection: "",
    obFolio: null,
    obHolding: null,
    isMandate: "",
    selectedOptionCode: ''
}

export default function categoryReducer(state = init, action) {
    switch (action.type) {

        case type.CAT_SAVE_SCHEMECODE:
            return {
                ...state,
                schemeCode: action.payload,
            }

        case type.CAT_SAVE_CARTID:
            return {
                ...state,
                cartId: action.payload,
            }

        case type.IS_MANDATE:
            return {
                ...state,
                isMandate: action.payload,
            }

        case type.SAVE_CART_BOX:
            let aaa = [...state.cartBoxData];
            aaa.push(action.payload)
            return {
                ...state,
                cartBoxData: aaa,
            }

        case type.REPLACE_CART_BOX:
            let newCartBoxData = [];
            newCartBoxData.push(action.payload)
            return {
                ...state,
                cartBoxData: newCartBoxData,
            }

        case type.DEL_CART_BOX:
            /* let bbb = [];
            state.cartBoxData.map((curr, ind)=> {
                if(curr.OrderId !== action.payload){
                    bbb.push(curr);
                }
            }) */
            let bbb = state.cartBoxData;
            bbb = bbb.filter(function (obj) {
                return Object.keys(obj)[0] !== action.payload;
            })
            return {
                ...state,
                cartBoxData: bbb,
            }

        case type.RESET_CART_BOX:
            return {
                ...state,
                cartBoxData: [],
            }
        case RESET_SELECTED_FUND:
            return {
                ...state,
                cartBoxData: [],
            }
        case type.ACTIVE_INVESTOR:
            return {
                ...state,
                activeInvestor: action.payload,
            }

        case type.ACTIVE_PANDROPDOWN:
            return {
                ...state,
                investorDrop: action.payload,
            }

        case type.PAN_AGAIN_FOLIO:
            return {
                ...state,
                panFolio: action.payload,
            }

        case type.FOLIO_SELECTION_CART:
            return {
                ...state,
                folioSelection: action.payload,
            }

        case type.OB_FOLIOHOLDING_DATA:
            return {
                ...state,
                obFolio: action.payload.folioNumber,
                obHolding: action.payload.holdingMode
            }

        case UPDATE_CART_ITEM_BY_SCHEME_CODE: {
            let aaa = [...state.cartBoxData];
            let payload = action.payload;

            let Scheme = payload.Scheme;
            // Scheme,Amount
            let schemeIndex = aaa.findIndex(sch => {
                let code = Object.keys(sch)[0];
                return code === Scheme
            });
            if (schemeIndex > -1) {
                aaa[schemeIndex] = {
                    [Scheme]: { ...aaa[schemeIndex][Scheme], ...payload }
                };
                return { ...state, cartBoxData: aaa }
            }
            return state;
        }

        case type.SAVE_OPTION_CODE:
            return {
                ...state,
                selectedOptionCode: action.payload,
            }

        default:
            return state
    }
}